
import { Request } from 'codeArt/common';

export class Tracker {
    constructor(props) {
        this.params = props.params;
        this.gta = window.gta;
        this.props = props;
    }

    get(r){
        return this.props.get ? this.props.get(r) : null;
    }

    getParams(){
        return this.params;
    }

    setPageVars(data){
        if(data)
            this.gta("page.set",data);
    }

    getPageVars(r){

    }

    enter(){
        let paras = this.getLoadParas ? this.getLoadParas() : null;
        if(paras){
            let my = this;
            Request.mute({
                ...paras,
                success: (r) => {
                    my.data = r;
                    this.tryPageEnter(r);
                }
            });
        }
        else{
            this.tryPageEnter();
        }
    }

    tryPageEnter(r){
        // let data = this.get(r);
        // if(data){  //只有写了url或者页面变量的，才能出发页面进入事件
        //     let {path,query,value,vars} = data;
        //     if(vars) this.gta("page.set",vars);
        //     this.gta("page.enter",{path,query,value}); //格式：{url,value}
        // }
    }
}